import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const resultSlides = lazy(() => import('../../container/resultSlides'));

const ResultSlideRoutes = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/resultSlides`} component={resultSlides}/>
        </Switch>
    );
};

export default ResultSlideRoutes;